module.exports = __webpack_public_path__ + "img/defaultPopUpImageUrl.49ecb175.jpg";